import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const UserDetailSlice = createSlice({
    name: "userDetail",
    initialState,
    reducers: {
        getUserDetailRequest(state) {
            state.loading = true;
        },
        getUserDetailRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        getUserDetailRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
    },
});

export const {
    getUserDetailRequest,
    getUserDetailRequestSuccess,
    getUserDetailRequestError,
} = UserDetailSlice.actions;

export default UserDetailSlice.reducer;
